module.exports = __webpack_public_path__ + "static/media/fn-logo.b5519c15.png";